import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_doacoes_vue = _resolveComponent("doacoes-vue")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_doacoes_vue, {
        onRefuse: _ctx.closedialog,
        dialog: _ctx.doacoes
      }, null, 8, ["onRefuse", "dialog"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doacoes = !_ctx.doacoes)),
          "prepend-icon": "mdi-hand-heart",
          class: "pulsing-btn donate-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Doar ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "6",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                color: "surface-variant",
                variant: "outlined",
                title: "Exames Ligeiro/ Pesados",
                "max-width": "300",
                class: "mx-auto"
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    to: { name: 'ExameList', params: { id: 1 } },
                    "append-icon": "mdi-chevron-right",
                    color: "red-lighten-2",
                    text: "Explorar",
                    variant: "outlined",
                    block: ""
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: require('@/assets/logo.png')
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "6",
            lg: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                color: "surface-variant",
                title: "Exames Profissional",
                "max-width": "300",
                class: "mx-auto"
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    to: { name: 'ExameList', params: { id: 2 } },
                    "append-icon": "mdi-chevron-right",
                    color: "red-lighten-2",
                    text: "Explorar",
                    variant: "outlined",
                    block: ""
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: require('@/assets/logo.png')
                  }, null, 8, ["src"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}